import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/compras/liquidacionGastos';
import Asignar from './AgregarProyectoFormTabs';


const ms2p = (state) => {
  return {
    ...state.liqGastos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Asignar);
